import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enFilterBar from './locales/en/filterBar.json'
import enCommon from './locales/en/common.json'
import fiFilterBar from './locales/fi/filterBar.json'
import fiCommon from './locales/fi/common.json'

const urlParams =
  typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search)
    : null
const localeFromUrl = urlParams?.get('locale') || 'fi'

i18n.use(initReactI18next).init({
  resources: {
    en: { filterBar: enFilterBar, common: enCommon },
    fi: { filterBar: fiFilterBar, common: fiCommon },
  },
  lng: localeFromUrl,
  fallbackLng: 'fi',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
